import { BaseApiConfiguration } from '../../common';
import { Http } from '../../common/api';

export const supportApiHttp = new Http();

export const initializeSupportApiHttp = (config: BaseApiConfiguration): void => {
  supportApiHttp.initializeHttp(`${config.baseUrl}`);
};
